import Reveal from "./Reveal";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  tone?: "light" | "dark";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  tone = "light",
}: SectionHeadingProps) {
  const isDark = tone === "dark";
  const alignment = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";

  return (
    <Reveal className={`flex flex-col ${alignment} max-w-2xl`}>
      <span
        className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] ${
          isDark
            ? "border-primary-400/30 bg-primary-500/10 text-primary-300"
            : "border-primary-200 bg-primary-50 text-primary-700"
        }`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
        {eyebrow}
      </span>
      <h2
        className={`mt-5 font-heading text-3xl font-bold leading-tight tracking-tight md:text-4xl ${
          isDark ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-4 text-base leading-relaxed md:text-lg ${isDark ? "text-background-200" : "text-foreground-600"}`}>
          {description}
        </p>
      )}
    </Reveal>
  );
}